import type { WeeklyClientRow } from '@st/contract';
import type { TFunction } from '../i18n/I18nProvider';
import type { ClientFlag } from '../ui';

/**
 * Klijenti koji traže pažnju, poredani po hitnosti (najhitniji prvi).
 *
 * Server već sortira, ali sortiramo i ovdje: popis se spaja s optimističnim
 * promjenama i mora ostati stabilan i kad podaci dođu iz cachea.
 * Kod jednake hitnosti odlučuje ime — inače bi se redoslijed vrtio bez razloga.
 */
export function attentionList(items: readonly WeeklyClientRow[]): WeeklyClientRow[] {
  return items
    .filter((i) => i.needsAttention)
    .sort((a, b) => b.urgency - a.urgency || a.name.localeCompare(b.name));
}

export function calmList(items: readonly WeeklyClientRow[]): WeeklyClientRow[] {
  return items.filter((i) => !i.needsAttention).sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Razlozi zašto klijent traži pažnju, poredani kao i hitnost:
 * nepročitana poruka i check-in traže odgovor danas, ostalo ovaj tjedan.
 */
export function weeklyReasons(row: WeeklyClientRow, t: TFunction): ClientFlag[] {
  const f = row.flags;
  const reasons: ClientFlag[] = [];
  if (f.unreadMessages > 0) {
    reasons.push({ label: t('weekly.reasonUnread', { n: f.unreadMessages }), tone: 'accent' });
  }
  if (f.pendingCheckIn) reasons.push({ label: t('weekly.reasonCheckIn'), tone: 'info' });
  if (f.missedWorkouts > 0) {
    reasons.push({ label: t('weekly.reasonMissed', { n: f.missedWorkouts }), tone: 'warning' });
  }
  if (f.lowAdherence) reasons.push({ label: t('weekly.reasonAdherence'), tone: 'danger' });
  if (f.stoppedLoggingMeals) reasons.push({ label: t('weekly.reasonMeals'), tone: 'neutral' });
  if (f.noMeasurements) reasons.push({ label: t('weekly.reasonMeasurements'), tone: 'neutral' });
  return reasons;
}
